import React from "react";
import { SVG, IconProps } from "../SVG";
export const DinersClub = (props: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 17" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#2183CB"
                d="M0 1.993C0 .893.897 0 2.005 0h19.99C23.102 0 24 .903 24 1.993v12.814c0 1.1-.897 1.993-2.005 1.993H2.005A2.006 2.006 0 0 1 0 14.807V1.993Z"
            />
            <path
                fill="#FFF"
                d="M12.872 3.511c2.742-.042 4.97 2.168 5.012 4.89v.042a5.003 5.003 0 0 1-5.012 4.847h-1.756c-2.656-.043-4.798-2.211-4.798-4.847-.085-2.636 1.97-4.847 4.584-4.932h1.97Zm-1.627.85c-2.228 0-4.07 1.829-4.07 4.04 0 2.21 1.842 4.039 4.07 4.039 2.227 0 4.069-1.829 4.069-4.04 0-2.21-1.842-4.039-4.07-4.039Zm.642 1.36c1.5.384 2.442 1.872 2.056 3.36a2.779 2.779 0 0 1-2.056 2.04v-5.4Zm-1.285 0v5.4a2.793 2.793 0 0 1-2.013-3.4 2.807 2.807 0 0 1 2.013-2Z"
            />
        </g>
    </SVG>
);
DinersClub.displayName = "DinersClub";
